import React from "react";
import useVersionOne from "./useVersionOne";
import {
  IconText,
  Image,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";

const VersionOne = ({ statusData }) => {
  const { excelFormData, itemID, certificateNumber } = useVersionOne();

  return (
    <div className="row gy-3">
      <div className="col-12">
        <h6 className="pro-ttl h6">{itemID}</h6>
        <p className="pro-ttl pro-mb-0">{certificateNumber}</p>
      </div>
      {/* Mapping Process */}
      <div className="col-6">
        <label className="pro-font-sm pro-mb-1 pro-fw-medium">Status</label>
        <Select
          id="status"
          name="status"
          placeholder={"Select"}
          className="pro-input lg"
          classNamePrefix="pro-input"
          options={statusData || []}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?.id}
          value={
            statusData?.find(
              (option) =>
                option?.id ===
                (excelFormData?.graded_values?.cvd_status ??
                  excelFormData?.process?.status)
            ) ?? ""
          }
          isDisabled={true}
        />
      </div>

      {/* Mapping Remarks */}
      <div className="col-6">
        <Input
          label="Remarks"
          type="text"
          id="remarks"
          name="remarks"
          value={
            excelFormData?.graded_values?.cvd_remark ?? excelFormData?.remarks
          }
          disabled={true}
        />
      </div>

      {/* Mapping Graded Values */}
      {excelFormData?.graded_values && (
        <>
          {Object.entries(excelFormData.graded_values)
            .filter(([key]) => key !== "cvd_status" && key !== "cvd_remark")
            .map(([key, values], index) => (
              <div className="col-6" key={index}>
                <div>
                  {key === "image" && values?.path ? (
                    <div>
                      <div className="input-wrap pro-mb-4">
                        <label
                          htmlFor=""
                          className={`pro-font-sm pro-mb-1 pro-fw-medium`}
                        >
                          Image
                        </label>
                        <div className="input-drag">
                          <input type="file" disabled={true} />
                          <span className="input-drag-box">
                            <IconText
                              title={values?.name || values?.original_name}
                            />
                          </span>
                        </div>
                        <div className={`col-2 pro-my-2`}>
                          <div className={``}>
                            <Image
                              src={values.path}
                              alt={values.original_name || "Uploaded image"}
                              height={200}
                              width={200}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : typeof values === "object" &&
                    values !== null &&
                    !Array.isArray(values) ? (
                    Object.entries(values).map(
                      ([fieldKey, fieldValue], subIndex) => (
                        <Input
                          key={subIndex}
                          label={fieldKey}
                          type="text"
                          id={`${key}-${fieldKey}`}
                          name={`${key}-${fieldKey}`}
                          value={fieldValue}
                          disabled
                        />
                      )
                    )
                  ) : (
                    <Input
                      label={key}
                      type="text"
                      id={key}
                      name={key}
                      value={values}
                      disabled
                    />
                  )}
                </div>
              </div>
            ))}
        </>
      )}
    </div>
  );
};

export default VersionOne;
